<template>
  <div>
    <slotBase :bg-grey="true" :loading="isLoading">
      <template v-slot:title>
        <titleBar :header-title="'akun'" />
      </template>
      <template v-slot:content>
        <div class="p-t-20 p-x-24">
          <cardProfile />
        </div>
        <div class="p-t-16 p-x-24">
          <cardLogout />
        </div>
        <bottomBar :akunPage="true" />
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import cardProfile from "../components/cardProfile.vue";
import cardLogout from "../components/cardLogout.vue";
import bottomBar from "@/components/design/bottomBar.vue";
import { mapActions } from "vuex";

export default {
  name: "akunPage",
  components: {
    slotBase,
    titleBar,
    cardProfile,
    cardLogout,
    bottomBar,
  },

  data() {
    return {
      isLoading: false,
    };
  },

  async mounted() {
    this.isLoading = true;
    await this.getIdUser().then((res) => {
      if (res.status == 200) {
        this.isLoading = false;
        let idUser = res.data.customer_global.id;
        this.getDataAkun(idUser);
      }
    });
  },
  methods: {
    ...mapActions({
      getIdUser: "akun/getIdUser",
      getDataAkun: "akun/getDataAkun",
    }),
  },
};
</script>
